<script>
// Sino de notificações do topbar: badge com a contagem de não-lidas e um
// dropdown com as últimas notificações + "Ver todas" (vai para a página de
// notificações). Fonte: store `notifications` (mesma da nav antiga).
import { mapGetters } from 'vuex'

const BELL_SIZE = 18
const MAX_PREVIEW = 5
const CORPO_MAX = 90

export default {
  name: 'TopbarNotifications',
  data() {
    return { BELL_SIZE }
  },
  computed: {
    ...mapGetters('notifications', ['notificacoes', 'qtdNotRead']),
    hasUnread() {
      return this.qtdNotRead > 0
    },
    unreadLabel() {
      return this.qtdNotRead > 99 ? '99+' : String(this.qtdNotRead)
    },
    preview() {
      return (this.notificacoes || []).slice(0, MAX_PREVIEW).map((n) => ({
        id: n.id,
        titulo: n.titulo || n.nome || 'Notificação',
        corpo: this.resumo(n.corpo || (n.conteudo && n.conteudo[0]) || ''),
      }))
    },
  },
  methods: {
    resumo(texto) {
      const limpo = String(texto).replaceAll(/<[^>]*>/g, '').trim()
      return limpo.length > CORPO_MAX ? `${limpo.slice(0, CORPO_MAX)}…` : limpo
    },
    verTodas() {
      if (this.$route && this.$route.name === 'notifications') return
      this.$router.push({ name: 'notifications' })
    },
  },
}
</script>

<template>
  <v-menu offset-y left min-width="340" max-width="360" :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <button class="tb-notif__bell" type="button" title="Notificações" v-on="on">
        <icon-svg name="bell" :size="BELL_SIZE" color="#030309" />
        <span v-if="hasUnread" class="tb-notif__badge">{{ unreadLabel }}</span>
      </button>
    </template>

    <div class="tb-notif">
      <header class="tb-notif__head">
        <span class="tb-notif__title">Notificações</span>
        <span v-if="hasUnread" class="tb-notif__count">{{ unreadLabel }} não lidas</span>
      </header>

      <div class="tb-notif__list">
        <div v-for="n in preview" :key="n.id" class="tb-notif__item">
          <span class="tb-notif__dot" />
          <div class="tb-notif__item-body">
            <span class="tb-notif__item-title">{{ n.titulo }}</span>
            <span v-if="n.corpo" class="tb-notif__item-text">{{ n.corpo }}</span>
          </div>
        </div>
        <div v-if="!preview.length" class="tb-notif__empty">
          Nenhuma notificação no momento.
        </div>
      </div>

      <button class="tb-notif__all" type="button" @click="verTodas">Ver todas</button>
    </div>
  </v-menu>
</template>

<style lang="sass" scoped>
.tb-notif__bell
  position: relative
  width: 38px
  height: 38px
  border-radius: 999px
  border: 1px solid #e4e4e4
  background: #fff
  cursor: pointer
  display: inline-flex
  align-items: center
  justify-content: center

  &:hover
    background: #f5f6fa

.tb-notif__badge
  position: absolute
  top: -4px
  right: -4px
  min-width: 16px
  height: 16px
  padding: 0 4px
  border-radius: 999px
  background: #eb5757
  color: #fff
  font-size: 9.5px
  font-weight: 700
  line-height: 16px
  text-align: center
  border: 2px solid #fff

.tb-notif
  background: #fff

  &__head
    display: flex
    align-items: center
    justify-content: space-between
    padding: 14px 16px 10px

  &__title
    font-size: 14px
    font-weight: 700
    color: #030309

  &__count
    font-size: 11px
    font-weight: 700
    color: var(--primary)

  &__list
    max-height: 320px
    overflow-y: auto

  &__item
    display: flex
    gap: 10px
    padding: 11px 16px
    border-top: 1px solid #f4f4f4

  &__dot
    flex-shrink: 0
    width: 8px
    height: 8px
    margin-top: 5px
    border-radius: 999px
    background: var(--primary)

  &__item-body
    min-width: 0
    display: flex
    flex-direction: column

  &__item-title
    font-size: 13px
    font-weight: 600
    color: #030309

  &__item-text
    font-size: 12px
    color: #8e8e8e
    margin-top: 2px

  &__empty
    padding: 28px 16px
    text-align: center
    font-size: 13px
    color: #8e8e8e

  &__all
    width: 100%
    padding: 12px
    border: 0
    border-top: 1px solid #ebebeb
    background: transparent
    color: var(--primary)
    font-size: 13px
    font-weight: 700
    cursor: pointer

    &:hover
      background: #f5f6fa
</style>
